import axios from 'axios';
import config from '../constants/config';
import { getAuthToken } from '../utils/utils';
import urlJoin from 'url-join';

export const emailAsyncValidate = (email, messages, brandId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        config.getApiUrl() +
          '/v2/users?login=' +
          encodeURIComponent(email) +
          '&brandId=' +
          brandId
      )
      .then((response) => {
        if (response.data.usedByMember) {
          throw { email: messages['error.form.email.already_exists'] };
        }
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getJsonData = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const fileUpload = (file) => {
  return new Promise((resolve, reject) => {
    axios
      .post(config.getApiUrl() + '/v2/files', file)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getFileById = (fileId) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: config.getApiUrl() + '/v2/files/' + fileId,
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': getAuthToken().token
      }
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const newFileUpload = (file) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);

  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: config.getApiUrl() + '/v3/files',
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createGetCountryIsoByIpAction = (fallbackCountry) => {
  return (success) => {
    getJsonData(config.geoIpUrl).then(
      (data = '') => success(data.split(';')[1] || fallbackCountry),
      () => success(fallbackCountry)
    );
  };
};

export const forwardGeocoding = (query, params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(urlJoin(config.mapboxEndpoint, 'mapbox.places', `${query}.json`), { params })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const reverseGeocoding = ([lat, lng], params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(urlJoin(config.mapboxEndpoint, 'mapbox.places', `${lng},${lat}.json`), {
        params
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
